import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=70287044&"
import script from "./AdminIndex.vue?vue&type=script&lang=js&"
export * from "./AdminIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports